const {
    mapLineItemsToSalesOrderRequestItem,
    mapShippingToSalesOrderDetailShipping,
    mapToOrderTotals,
    mapToSalesOrderPayments
} = require('./mappings');

const toSalesOrderRequest = (order) => {
    return {
        OrderAction: order.action,
        Reason: order.reason,
        Pricing: order.pricing,
        ExternalID: order.externalId,
        ...(order.adr && order.adr.adrOverrideId && {ADROverrideID: order.adr.adrOverrideId}),
        CountryCode: order.countryCode,
        SoldToMemberID: order.soldToMemberId,
        ProductDiscountCode: order.productDiscountCode,
        ShippingDiscountCode: order.shippingDiscountCode,
        Category: order.category,
        Item: mapLineItemsToSalesOrderRequestItem(order),
        Shipping: mapShippingToSalesOrderDetailShipping(order),
        ...(order.orderTotals && {OrderTotals: mapToOrderTotals(order)}),
        Payment: mapToSalesOrderPayments(order),
        Custom: [
            ...(order.eventCode && [{Type: 'EVENT', Key: 'CODE', Value: order.eventCode}] || []),
            ...(order.adr && order.adr.adrContractLength && [{Value: order.adr.adrContractLength, Key: 'ADR_CONTRACT_LENGTH'}] || []),
            ...(order.sender && [{Key: 'SENDER', Value: order.sender}] || []),
            ...(order.shippingPayWithPoints && [{Value: order.shippingPayWithPoints, Key: 'ZZUSE_PTS'}] || []),
            ...(order.microsite && [{Value: order.microsite, Key: 'REASON', Type: 'REASON'}] || [])
        ]
    }
};

module.exports = toSalesOrderRequest;
